import Control from "../../1. Core/Control";
import NP, {IHash} from "../../1. Core/NP";

import Label from "../../1. Core/Controls/Label/Label";
import Delegate from "../../1. Core/Delegate";
import {loadFile, loadFiles} from "../../1. Core/ScriptLoader";


export default class TechTable extends Control {
	private _Instance: any;
	private _gridOptions: any;
	private _lbl: Label;

	public EvRefreshed: Delegate;
	private _noDataLabel: Label;


	_initFields(settings: object)
	{
		this.EvRefreshed = new Delegate();
		super._initFields(settings);
	}

	constructor(settings?: object)
	{
		super(settings);
		this._render();
	}

	_render()
	{
		this._initComponent('<div class="tech-table ag-theme-balham"></div>');

		this._lbl = new Label({
			ParentNode: this._root,
			RK: 'Technical report'
		});

		this._br();

		this._noDataLabel = new Label({
			ParentNode: this._root,
			RK: 'NoData'
		});

		this._noDataLabel.setIsVisible(false);

		if (this._ParentNode)
			this.putToNode(this._ParentNode);
	}


	refresh(data: number[][])
	{
		if (this._Instance)
			this._Instance.destroy();

		if (!(<any>window).AgGrid)
			return loadFiles(['ag-grid.js', 'ag-grid.css']).then(() => this.isLive() && this.refresh(data));


		if (!data || !data.length)
		{
			this._noDataLabel.setIsVisible(true);
			this.EvRefreshed.fire(this);
			return;
		}
		else
			this._noDataLabel.setIsVisible(false);


		let columnDefs: any[] = [];



		columnDefs.push({
				 headerName: NP.RM.getString("Round")
			 },
			 {
				 headerName: NP.RM.getString("Total punches"),
				 children: this.getChildColumns()
			 },
			 {
				 headerName: NP.RM.getString("Jabs"),
				 children: this.getChildColumns()
			 },
			 {
				 headerName: NP.RM.getString("Power punches"),
				 children: this.getChildColumns()
			 },
			 {
				 headerName: NP.RM.getString("Knockdowns"),
				 children: [
					 {headerName: NP.RM.getString("Red")},
					 {headerName: NP.RM.getString("Blue")}
				 ]
			 },
			 {
				 headerName: NP.RM.getString('TechnicalEvaluation'),
				 children: [
					 {headerName: NP.RM.getString("Red")},
					 {headerName: NP.RM.getString("Blue")}
				 ]
			 });

		this.setColField(columnDefs, 0);

		let rowData = [],
			 format = {
				 f: "0,0.00",
				 m: '{{Value}}'
			 };

		let percColIndexex = [5, 6, 11, 12, 17, 18];

		for (let i = 0; i < data.length; i++)
		{
			let res = {} as IHash<string>;
			data[i].forEach((cell: any, index: number) =>
			{
				if (cell == 'NaN' || cell == null)
					return;
				res[index] = percColIndexex.indexOf(index) > -1 ? NP.applyFormat(cell, format, 2) : cell;
			});
			rowData.push(res);
		}

		this.formatCells(columnDefs);

		this._Instance = new (window as any).AgGrid(this._root, this._gridOptions = {
			columnDefs: columnDefs,
			rowData: rowData,
			"headerHeight": 40,
			"enableSorting": false,
			"animateRows": true,
			domLayout: 'autoHeight',
			"enableColResize": false,
			"suppressPropertyNamesCheck": true,
			"suppressRowClickSelection": true,
			"suppressColumnVirtualisation": true,
			getRowStyle: function (params: any)
			{
				if (params.node.rowIndex % 2 == 0)
				{
					return {background: 'rgba(0, 0, 0, 0.12)'}
				}
			},
			onFirstDataRendered: (() =>
			{
				if (this._gridOptions)
				{
					let allColumnIds = this._gridOptions.columnApi.getAllColumns().map((column: any) => column.colId);
					this._gridOptions.columnApi.autoSizeColumns(allColumnIds);

					this._root.style.width = (this._root.querySelector(".ag-header-container") as HTMLElement).offsetWidth + 2 + 'px';
					this.EvRefreshed.fire(this);
				}
			})
		});

	}

	getChildColumns()
	{
		return [
			{
				headerName: NP.RM.getString("Total2"),
				children: [{
					headerName: NP.RM.getString("Red")
				},
					{
						headerName: NP.RM.getString("Blue")
					}
				]
			},
			{
				headerName: NP.RM.getString("Accurate2"),
				children: [{
					headerName: NP.RM.getString("Red")
				},
					{
						headerName: NP.RM.getString("Blue")
					}
				]
			},
			{
				headerName: "%",
				children: [{
					headerName: NP.RM.getString("Red")
				},
					{
						headerName: NP.RM.getString("Blue")
					}
				]
			}
		]
	}

	getCellStyle(params?: any, compareIndex?: number)
	{
		let style: any = {};
		style.textAlign = 'center';

		if (!isNaN(compareIndex) && parseFloat(params.value) > parseFloat(params.data[compareIndex]))
			 style.fontWeight = '700';

      return style;
	}

	setColField(columnDefs: any[], index: number)
	{
		for (let col of columnDefs)
		{
			if (col.children)
			{
				index = this.setColField(col.children, index);
			}
			else
			{
				col.field = "" + index++;
			}
			col.cellStyle = this.getCellStyle;
		}
		return index;
	}

	formatCells(columnDefs: any[])
	{
		for (let col of columnDefs)
		{
			if (col.children)
			{
				if (col.children.length === 2 && col.children[0].headerName === 'Red' && col.children[1].headerName === 'Blue')
				{
					col.children[0].cellStyle = (params: any) => this.getCellStyle(params, col.children[1].field);
					col.children[1].cellStyle = (params: any) => this.getCellStyle(params, col.children[0].field);
				}
				else
					this.formatCells(col.children);
			}
		}
	}

	clear()
	{
		if (this._Instance)
		{
			this._Instance.destroy();
			this._Instance = null;
		}
	}
}